import React from "react";
import { Link } from "react-router-dom";

const Panduan = () => {
    return (
        <div className="p-6 bg-base-100 min-h-screen">
            <h1 className="text-3xl font-bold mb-6">Panduan Penggunaan</h1>

            {/* Collapse 1 */}
            <div
                tabIndex={0}
                className="collapse collapse-plus border border-base-300 bg-base-200 rounded-box mb-4"
            >
                <div className="collapse-title text-xl font-medium">
                    Cara Melakukan Deposit
                </div>
                <div className="collapse-content">
                    <p>1. Pilih metode pembayaran yang Anda inginkan:</p>
                    <ul className="list-disc pl-6">
                        <li>DANA: 081952545612</li>
                        <li>SEA BANK: 901030212504</li>
                        <li>GOPAY: 081952545612</li>
                    </ul>
                    <p>
                        2. Lakukan transfer ke nomor rekening atau akun di atas
                        sesuai nominal deposit yang Anda pilih.
                    </p>
                    <p>
                        3. Jika saldo belum bertambah setelah melakukan transfer,
                        silakan hubungi admin melalui tautan berikut:{" "}
                        <Link
                            className="text-red-500"
                            to="https://wa.me/6282241515135"
                        >
                            Hubungi Admin
                        </Link>
                        .
                    </p>
                    <p>
                        4. Saldo akan bertambah secara otomatis setelah langkah 1
                        dan 2 selesai dilakukan.
                    </p>
                    <div role="alert" className="alert">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            className="stroke-info h-6 w-6 shrink-0"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                        </svg>
                        <p>
                            <strong>Informasi Penting:</strong> Website ini dibuat oleh{" "}
                            <Link
                                className="text-red-500"
                                to="https://wa.me/6285867760406"
                            >
                                Padildev
                            </Link>
                            . Admin berkomitmen untuk menjaga kepercayaan pengguna
                            dan tidak melakukan penipuan. Anda dapat merasa aman
                            saat menggunakan layanan ini.
                        </p>
                    </div>
                </div>
            </div>

            {/* Collapse 2 */}
            <div
                tabIndex={0}
                className="collapse collapse-plus border border-base-300 bg-base-200 rounded-box mb-4"
            >
                <div className="collapse-title text-xl font-medium">
                    Cara Membuat Pesanan
                </div>
                <div className="collapse-content">
                    <p>Ikuti langkah-langkah berikut:</p>
                    <ul className="list-disc pl-6">
                        <li>Pastikan saldo Anda mencukupi.</li>
                        <li>
                            Sebelum membeli, pastikan membaca deskripsi atau
                            aturan yang tertera pada produk.
                        </li>
                        <li>
                            Untuk melihat deskripsi produk, tekan tombol{" "}
                            <span className="text-primary">Details</span>.
                        </li>
                    </ul>
                </div>
            </div>

            {/* Collapse 3 */}
            <div
                tabIndex={0}
                className="collapse collapse-plus border border-base-300 bg-base-200 rounded-box"
            >
                <div className="collapse-title text-xl font-medium">
                    Cara Mengakses Pesanan yang Sudah Dibeli
                </div>
                <div className="collapse-content">
                    <p>
                        Setelah pembelian, buka menu inbox yang terletak di pojok
                        kanan atas, di sebelah kiri tombol keranjang. Anda dapat
                        melihat daftar pesanan yang sudah dibeli di sana.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Panduan;
